import React from 'react'
import ResumoGeral from '../../components/performance/ResumoGeral'

export default function PerformancePage() {
  return (
    
            <ResumoGeral />
          
  )
}
